import React, { useState } from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import HorizontalNav from './HorizontalNav';
import VerticalNav from './VerticalNav';
import UserProfile from './UserProfile';
import useDispatch from '../../utils/hooks/useDispatch';
import { setHeaderHeight } from '../../apps/settings/action-creators';

const { Header } = Layout;

function Topbar() {
  const dispatch = useDispatch();

  const [showBurgerMenu, setShowBurgerMenu] = useState(false);

  const headerRef = React.useRef<null | HTMLDivElement>(null);

  const handleResize = () => {
    if (headerRef.current) dispatch(setHeaderHeight(headerRef.current?.clientHeight));
  };

  React.useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  React.useEffect(() => {
    if (headerRef.current) dispatch(setHeaderHeight(headerRef.current?.clientHeight));
  }, [headerRef.current]);

  return (
    <div
      className="gx-header-horizontal gx-header-horizontal-dark gx-inside-header-horizontal"
      style={{ overflow: 'hidden' }}
      ref={(el) => headerRef.current = el}
    >
      <Header className="gx-header-horizontal-main">
        <div className="gx-container gx-header-horizontal-nav">
          <div style={{ height: '71px' }} className="gx-header-horizontal-main-flex">
            <div className="gx-d-lg-none gx-burger-menu-trigger" onClick={() => setShowBurgerMenu(!showBurgerMenu)}>
              {showBurgerMenu ? <CloseOutlined /> : <MenuOutlined />}
            </div>
            {/*<Link to="/" className="gx-d-block gx-d-lg-none gx-pointer gx-mr-xs-3 gx-pt-xs-1 gx-w-logo gx-m-auto">*/}
            {/*  Дашборд*/}
            {/*</Link>*/}

            {/*<Link to="/" className="gx-d-none gx-d-lg-block gx-pointer gx-mr-xs-5 gx-logo">*/}
            {/*  Дашборд*/}
            {/*</Link>*/}

            <div className="ant-menu-dark gx-d-none gx-d-sm-none gx-d-xs-none gx-d-md-none gx-d-lg-block">
              <HorizontalNav />
            </div>

            <div className="gx-flex-1"/>

            <ul className="gx-header-notifications gx-ml-lg-auto">
              <li className="gx-user-nav"><UserProfile /></li>
            </ul>
          </div>
          <div className={`ant-menu-dark gx-d-lg-none gx-burger-menu ${!showBurgerMenu && ' gx-burger-menu-hide'}`}>
            <VerticalNav onClick={() => setShowBurgerMenu(false)} />
          </div>
        </div>
      </Header>
    </div>
  );
}

export default Topbar;
